import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-test": "erm-error"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { "data-test": "erm-message" }
const _hoisted_4 = { class: "controls" }

import { computed } from "vue";
import { Modal } from "uiv";
import { TeamCurrentMemberApiModel } from "../../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'edit-role-modal',
  props: {
    member: {},
    showRoleModal: { type: Boolean },
    role: {},
    error: { type: Boolean },
    isAddingRole: { type: [Boolean, null] }
  },
  emits: ["close-role-modal", "confirm-role"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const memberFullName = computed(() => {
  return `${props.member.userDetails.firstName} ${props.member.userDetails.lastName}`;
});

const showModal = computed(() => {
  return props.showRoleModal;
});

const closeRoleModal = (): void => {
  emit("close-role-modal");
};

const confirmRole = (member: TeamCurrentMemberApiModel, role: string): void => {
  emit("confirm-role", member, role);
};

return (_ctx: any,_cache: any) => {
  return (props.member)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        modelValue: showModal.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event)),
        header: false,
        "data-test": "erm-modal"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: closeRoleModal,
              "data-test": "erm-close",
              type: "button"
            }, " Cancel "),
            _createElementVNode("button", {
              class: "btn btn-default",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (confirmRole(_ctx.member, _ctx.role))),
              "data-test": "erm-confirm",
              type: "button"
            }, " Confirm ")
          ])
        ]),
        default: _withCtx(() => [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_1, " Oops, there was an error editing this member's roles. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("h2", _hoisted_3, " Are you sure you want to " + _toDisplayString(_ctx.isAddingRole ? "add" : "remove") + " " + _toDisplayString(memberFullName.value) + " as a " + _toDisplayString(_ctx.role.toLowerCase() === "admin" ? "team lead" : _ctx.role.toLowerCase()) + "? ", 1)
              ]))
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})